export const baseURL = String(process.env.REACT_APP_CONFIG);
export const baseURLStudent = String(process.env.REACT_APP_STUDENT_URL);
export const baseURLEmployee = String(process.env.REACT_APP_EMPLOYEE_URL);
export const baseURLAbiturient = String(process.env.REACT_APP_ABITURIENT_URL);
export const baseURLJob = String(process.env.REACT_APP_JOB_URL);
export const baseAuthLoginURL = String(process.env.REACT_APP_AUTH_LOGIN_URL);
